import type { ApiSshKey, SshKey } from "./types";

export const normalizeSshKey = ({
  id,
  value,
  label,
  active
}: ApiSshKey): SshKey => ({ id, value, label, active });
